export default __webpack_public_path__ + "static/media/query.7e1f7164.svg";